/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MediaMinimal } from './MediaMinimal';
import {
    MediaMinimalFromJSON,
    MediaMinimalFromJSONTyped,
    MediaMinimalToJSON,
    MediaMinimalToJSONTyped,
} from './MediaMinimal';
import type { Persona } from './Persona';
import {
    PersonaFromJSON,
    PersonaFromJSONTyped,
    PersonaToJSON,
    PersonaToJSONTyped,
} from './Persona';

/**
 * 
 * @export
 * @interface ChatMessage
 */
export interface ChatMessage {
    /**
     * Unique identifier of the chat message
     * @type {string}
     * @memberof ChatMessage
     */
    id: string;
    /**
     * The persona that sent this message
     * @type {Persona}
     * @memberof ChatMessage
     */
    sender: Persona;
    /**
     * The text content of the message
     * @type {string}
     * @memberof ChatMessage
     */
    text: string;
    /**
     * List of media attachments for this message
     * @type {Array<MediaMinimal>}
     * @memberof ChatMessage
     */
    attachments: Array<MediaMinimal>;
    /**
     * The time this message was created
     * @type {Date}
     * @memberof ChatMessage
     */
    createdAt: Date;
}

/**
 * Check if a given object implements the ChatMessage interface.
 */
export function instanceOfChatMessage(value: object): value is ChatMessage {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('sender' in value) || value['sender'] === undefined) return false;
    if (!('text' in value) || value['text'] === undefined) return false;
    if (!('attachments' in value) || value['attachments'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function ChatMessageFromJSON(json: any): ChatMessage {
    return ChatMessageFromJSONTyped(json, false);
}

export function ChatMessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChatMessage {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'sender': PersonaFromJSON(json['sender']),
        'text': json['text'],
        'attachments': ((json['attachments'] as Array<any>).map(MediaMinimalFromJSON)),
        'createdAt': (new Date(json['createdAt'])),
    };
}

export function ChatMessageToJSON(json: any): ChatMessage {
    return ChatMessageToJSONTyped(json, false);
}

export function ChatMessageToJSONTyped(value?: ChatMessage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'sender': PersonaToJSON(value['sender']),
        'text': value['text'],
        'attachments': ((value['attachments'] as Array<any>).map(MediaMinimalToJSON)),
        'createdAt': value['createdAt'].toISOString(),
    };
}

